<header class="eiq-header-title">
  <mat-toolbar class="eiq-header-title__content">
    <div class="eiq-header-title__content__info">
      <h1 class="fs__xxl fw__600">{{ title() }}</h1>
      <span class="fs__sm fw__400 subtitle">{{ subtitle() }}</span>
    </div>

    <ng-content select="[slot=actions]"></ng-content>
  </mat-toolbar>
</header>

